import { usersApi } from 'entities/users';
import { CategoryType, PartnersType, ShopType } from 'widgets/product/model/types';

const getShopsApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getShops: builder.query<ShopType[], { per_page: number; page: number; search: string }>({
      query: ({ per_page, page, search }) => ({
        url: `/shop/admin/v1/product/get-products?per_page=${per_page}&page=${page}&search=${search}`,
      }),
      providesTags: ['Shops'],
    }),
    getShopsById: builder.query<ShopType, { id: number }>({
      query: ({ id }) => ({
        url: `/shop/admin/v1/product/get-product-by-id?product_id=${id}`,
      }),
      providesTags: ['Shops'],
    }),
    getCategory: builder.query<CategoryType[], { per_page: number; page: number; order: number }>({
      query: ({ per_page, page, order }) => ({
        url: `/shop/admin/v1/product-category/get-product-categories?per_page=${per_page}&page=${page}&order=${order}`,
      }),
      providesTags: ['Category'],
    }),
    getPartners: builder.query<PartnersType[], { per_page: number; page: number; order: number }>({
      query: ({ per_page, page, order }) => ({
        url: `/shop/admin/v1/partner/get-partners?per_page=${per_page}&page=${page}&order=${order}`,
      }),
      providesTags: ['Partners'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetShopsQuery, useGetShopsByIdQuery, useGetCategoryQuery, useGetPartnersQuery } = getShopsApi;
